var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 67.367,
    viewBox: "0 0 186 67.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7118",
    "data-name": "Group 7118",
    transform: "translate(-80 -71.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Imagotipo_normal_-_V1",
    "data-name": "Imagotipo normal - V1",
    transform: "translate(80 71.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M397.8,229.149a1.352,1.352,0,0,0-1.876.372,4.094,4.094,0,0,1-.491.6,3.905,3.905,0,0,1-5.525,0,4.094,4.094,0,0,1-.491-.6,1.354,1.354,0,1,0-2.252,1.5,6.615,6.615,0,0,0,10.182,1.012,6.754,6.754,0,0,0,.828-1.012A1.354,1.354,0,0,0,397.8,229.149Z",
    transform: "translate(-315.084 -186.315)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M361.151,140.605h0a14.793,14.793,0,0,0-7.563-1.94,14.487,14.487,0,0,0-7.379,1.921,14.245,14.245,0,0,0-5.231,5.257,15.208,15.208,0,0,0-1.992,7.535v23.9a2.79,2.79,0,1,0,5.568,0v-13.46a13.074,13.074,0,0,0,3.905,2.955,14,14,0,0,0,13.088-.558,13.851,13.851,0,0,0,4.96-5.261,15.469,15.469,0,0,0,1.832-7.528,14.781,14.781,0,0,0-1.94-7.561A14.463,14.463,0,0,0,361.151,140.605Zm1.783,12.813a10.085,10.085,0,0,1-1.226,4.964,9.3,9.3,0,0,1-3.325,3.474,8.991,8.991,0,0,1-4.744,1.272,9.15,9.15,0,0,1-4.748-1.248,8.839,8.839,0,0,1-3.292-3.468,11.021,11.021,0,0,1,0-10.011,9.094,9.094,0,0,1,3.3-3.472,9.484,9.484,0,0,1,9.484,0,9.3,9.3,0,0,1,3.325,3.474A10.194,10.194,0,0,1,362.935,153.419Z",
    transform: "translate(-276.059 -112.876)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M548.034,139.069h0a8.6,8.6,0,0,0-4.487-.96,11.66,11.66,0,0,0-8.413,3.513v-.463a2.448,2.448,0,0,0-2.732-2.732,2.51,2.51,0,0,0-2.732,2.732v23.579a2.741,2.741,0,1,0,5.469.006V149.494a5.5,5.5,0,0,1,1.361-3.81,7.718,7.718,0,0,1,3.8-2.178,13.427,13.427,0,0,1,5.564-.153,4.948,4.948,0,0,0,1.449.112,2.232,2.232,0,0,0,1.255-.493,2.477,2.477,0,0,0,.766-1.279A2.35,2.35,0,0,0,548.034,139.069Z",
    transform: "translate(-431.344 -112.423)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M659.422,140.509h0a13.42,13.42,0,0,0-7.1-1.839,14.337,14.337,0,0,0-7.355,1.888,13.347,13.347,0,0,0-5.021,5.207,15.837,15.837,0,0,0-1.806,7.656,15.028,15.028,0,0,0,1.914,7.612,13.725,13.725,0,0,0,5.313,5.222,15.914,15.914,0,0,0,12.878.954,14.38,14.38,0,0,0,4.45-2.358,2.006,2.006,0,0,0,.915-1.776,2.621,2.621,0,0,0-1-1.826,2.432,2.432,0,0,0-1.685-.573,3.162,3.162,0,0,0-1.756.616,10.177,10.177,0,0,1-2.732,1.4,9.9,9.9,0,0,1-3.329.6,10.194,10.194,0,0,1-5.142-1.276,9.326,9.326,0,0,1-3.5-3.5,9.485,9.485,0,0,1-1.1-3.083h19.69a2.572,2.572,0,0,0,1.847-.692,2.367,2.367,0,0,0,.729-1.78,16.483,16.483,0,0,0-1.592-7.385A12.158,12.158,0,0,0,659.422,140.509Zm1.023,10.342H643.423a10.828,10.828,0,0,1,.839-2.561,8.182,8.182,0,0,1,3.135-3.509,9.262,9.262,0,0,1,4.924-1.27,7.991,7.991,0,0,1,4.424,1.188,7.894,7.894,0,0,1,2.83,3.254,10.045,10.045,0,0,1,.869,2.9Z",
    transform: "translate(-519.688 -112.88)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M824.81,99.394l9.585-8.594a2.477,2.477,0,0,0,.861-1.772,2.509,2.509,0,0,0-.731-1.817,2.315,2.315,0,0,0-1.735-.872,2.5,2.5,0,0,0-1.823.744L818.275,98.427V77.282a2.622,2.622,0,0,0-.744-1.93,2.688,2.688,0,0,0-1.981-.744,2.568,2.568,0,0,0-2.682,2.674V113.1a2.568,2.568,0,0,0,2.68,2.682,2.684,2.684,0,0,0,1.981-.744,2.617,2.617,0,0,0,.744-1.93v-7.848L820.9,102.9l9.869,12.181a2.5,2.5,0,0,0,1.8.986c.078,0,.156.009.232.009a2.717,2.717,0,0,0,1.733-.638,2.63,2.63,0,0,0,.974-1.787,2.445,2.445,0,0,0-.621-1.86Z",
    transform: "translate(-661.996 -60.729)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5751",
    "data-name": "Path 5751",
    d: "M974.292,140.293A2.79,2.79,0,0,0,969.5,142.3v23.469a2.79,2.79,0,1,0,5.566,0V142.292A2.734,2.734,0,0,0,974.292,140.293Z",
    transform: "translate(-789.497 -113.512)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M970.4,87.308a3.057,3.057,0,0,0,2.28-.96,3.122,3.122,0,0,0,.93-2.254,3.04,3.04,0,0,0-.96-2.308,3.254,3.254,0,0,0-4.51,0,3.041,3.041,0,0,0-.959,2.308,3.279,3.279,0,0,0,3.215,3.214Z",
    transform: "translate(-787.615 -65.836)",
    fill: "#03fce8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M56.227,28.8A14.407,14.407,0,1,1,70.634,14.4,14.407,14.407,0,0,1,56.227,28.8Zm0-26.748A12.343,12.343,0,1,0,68.568,14.4,12.343,12.343,0,0,0,56.227,2.056Z",
    transform: "translate(-34.042 0.01)",
    fill: "#03fce8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5754",
    "data-name": "Path 5754",
    d: "M16.29,90.05v35.871a2.591,2.591,0,0,0,2.591,2.591H52.169a2.589,2.589,0,0,0,2.589-2.591V90.05Z",
    transform: "translate(-13.26 -73.302)",
    fill: "#edebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5755",
    "data-name": "Path 5755",
    d: "M0,122.44v4.173a4.394,4.394,0,0,0,4.452,4.452A4.394,4.394,0,0,0,8.9,126.613V122.44Z",
    transform: "translate(0.002 -99.668)",
    fill: "#4816a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5756",
    "data-name": "Path 5756",
    d: "M47.88,122.44v4.173a4.452,4.452,0,0,0,8.9,0V122.44Z",
    transform: "translate(-38.975 -99.668)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5757",
    "data-name": "Path 5757",
    d: "M95.76,122.44v4.173a4.452,4.452,0,0,0,8.9,0V122.44Z",
    transform: "translate(-77.951 -99.668)",
    fill: "#4816a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5758",
    "data-name": "Path 5758",
    d: "M143.64,122.44v4.173a4.453,4.453,0,1,0,8.907,0V122.44Z",
    transform: "translate(-116.927 -99.668)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5759",
    "data-name": "Path 5759",
    d: "M191.53,122.44v4.173a4.452,4.452,0,0,0,8.9,0V122.44Z",
    transform: "translate(-155.971 -99.668)",
    fill: "#4816a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5760",
    "data-name": "Path 5760",
    d: "M10.853,74.56H3.07L0,83.464H8.9Z",
    transform: "translate(0 -60.692)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5761",
    "data-name": "Path 5761",
    d: "M57.433,74.56h-7.6l-1.949,8.9h8.9Z",
    transform: "translate(-38.975 -60.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5762",
    "data-name": "Path 5762",
    d: "M104.015,74.56H96.409l-.649,8.9h8.9Z",
    transform: "translate(-77.951 -60.692)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5763",
    "data-name": "Path 5763",
    d: "M147.756,74.56H140.15l.649,8.9h8.906Z",
    transform: "translate(-114.086 -60.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5764",
    "data-name": "Path 5764",
    d: "M188.833,74.56H181.05l1.949,8.9h8.9Z",
    transform: "translate(-147.437 -60.692)",
    fill: "#5f1bcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5765",
    "data-name": "Path 5765",
    d: "M75.7,231.422a12.382,12.382,0,0,1-8.813-3.651,12.592,12.592,0,0,1-1.562-1.906,2.55,2.55,0,0,1,4.238-2.836,7.492,7.492,0,0,0,.93,1.131,7.366,7.366,0,0,0,10.414,0,7.493,7.493,0,0,0,.93-1.131,2.551,2.551,0,0,1,4.244,2.83,12.589,12.589,0,0,1-1.562,1.906A12.384,12.384,0,0,1,75.7,231.422Z",
    transform: "translate(-52.824 -180.627)",
    fill: "#5f1bcd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreki);
export default __webpack_public_path__ + "static/media/preki.5fd25d295dbae73bbf6a8afccedd2741.svg";
export { ForwardRef as ReactComponent };